import React, { useState } from "react";
import Link from "next/link";

import type { SubDrawer } from "../navbarData";

type Props = { drawer: SubDrawer };

export default function SubDropdown({ drawer }: Props) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [hoveredRight, setHoveredRight] = useState<number | null>(null);
  const [showRight, setShowRight] = useState(false);

  if (!drawer) return null;

  const leftItems = drawer.items || [];
  const active = activeIndex !== null ? leftItems[activeIndex] : null;
  const rightItems = active ? active.subItems || [] : [];

  return (
    <div className="navbar__dropdown-inner flex gap-0" role="menu" aria-label={drawer.title}>
      {/* Left Panel */}
      <div
        className={`navbar__dropdown-left navbar-dropdown-scroll bg-white p-4 max-h-[419px] overflow-y-auto relative ${showRight ? 'pr-0 w-[317px] min-w-[317px] rounded-tl-2xl rounded-bl-2xl rounded-tr-none rounded-br-none' : 'w-[334px] min-w-[334px] rounded-2xl'}`}
      >
        {leftItems.map((item, i) => {
          const isActive = i === activeIndex && showRight;

          return (
            <Link
              key={item.label + i}
              href={item.href}
              title={item.label}
              style={{ backgroundColor: isActive ? '#c7f8ff' : undefined }}
              className={`navbar__dropdown-left-item block w-full text-left border-none mb-1.5 last:mb-0 text-[#1b365e] font-bold text-xs cursor-pointer relative focus:outline-none focus:shadow-none transition-all no-underline hover:bg-[#c7f8ff]!
                ${isActive
                  ? 'is-active text-[#1b365e] font-bold rounded-l-full shadow-none z-2 p-[10px_0px_10px_16px]'
                  : 'bg-transparent rounded-l-full p-[10px_16px]'
                }`}
              onMouseEnter={() => {
                setActiveIndex(i);
                const current = leftItems[i];
                setShowRight(!!(current?.subItems?.length));
              }}
            >
              {item.label}
            </Link>
          );
        })}
      </div>

      {/* Right Panel */}
      {showRight && (
        <div className="navbar__dropdown-right bg-[#c7f8ff] p-4 min-w-[276px] h-fit flex items-start relative z-[2] ml-0 rounded-r-2xl">
          <div className="navbar__dropdown-right-inner w-full flex flex-col gap-2.5">
            {rightItems.length === 0 && (
              <div className="navbar__dropdown-right-empty text-[#1b365e] font-bold text-xs">
                Aucun sous-élément
              </div>
            )}
            {rightItems.map((r, idx) => (
              <Link
                key={r.label + idx}
                href={r.href}
                title={r.label}
                className={`navbar__dropdown-right-item h-[34px] inline-block bg-white p-[8px_20px] rounded-full text-[#1b365e] font-bold text-xs no-underline transition-all ${hoveredRight === idx
                  ? 'is-selected bg-[#123254] text-white'
                  : ''
                  } hover:bg-[#123254] hover:text-white`}
                onMouseEnter={() => setHoveredRight(idx)}
                onMouseLeave={() => setHoveredRight(null)}
              >
                {r.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
